import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { LanguageCode } from '@app-shared/enums/language-codes.enum';
import { environment } from 'src/environments/environment';
import { PartialTranslocoConfig } from '@ngneat/transloco/lib/transloco.config';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

export const translocoAppConfig: PartialTranslocoConfig = {
  availableLangs: [
    LanguageCode.EN_GB,
    LanguageCode.DE_DE,
    LanguageCode.ES_ES,
    LanguageCode.IT_IT,
    LanguageCode.FR_FR,
    LanguageCode.DE_CH,
    LanguageCode.CS_CZ,
    LanguageCode.NL_BE,
  ],
  defaultLang: LanguageCode.EN_GB,
  // Remove this option if your application
  // doesn't support changing language in runtime.
  reRenderOnLangChange: true,
  prodMode: environment.production,
  fallbackLang: LanguageCode.EN_GB,
  failedRetries: 1,
  missingHandler: {
    useFallbackTranslation: true,
  },
};
